import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import NavbarMobileLayoutFinanceiro from 'app/fuse-layouts/layout-financeiro/components/NavbarMobileLayoutFinanceiro';
import NavbarMobileToggleFab from 'app/fuse-layouts/shared-components/NavbarMobileToggleFab';
import * as Actions from 'app/store/actions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import NavbarLayoutFinanceiro from './NavbarLayoutFinanceiro';

const navbarWidth = 280;

const useStyles = makeStyles((theme) => ({
  navbar: {
    display: 'flex',
    overflow: 'hidden',
    height: 56,
    minHeight: 56,
    alignItems: 'center',
    boxShadow: theme.shadows[3],
    zIndex: 6,
    background: theme.palette.primary.main,
  },
  navbarMobile: {
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    width: navbarWidth,
    minWidth: navbarWidth,
    height: '100%',
    zIndex: 4,
    transition: theme.transitions.create(['width', 'min-width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
    boxShadow: theme.shadows[3],
  },
}));

function NavbarWrapperLayoutFinanceiro(props) {
  const dispatch = useDispatch();
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
  const navbarTheme = useSelector(({ fuse }) => fuse.settings.navbarTheme);
  const navbar = useSelector(({ fuse }) => fuse.navbar);
  const location = useLocation();
  const user = useSelector(({ auth }) => auth.user);
  const classes = useStyles(props);

  return (
    !location?.pathname.includes('/public/') && (
      <>
        {!user.role || user.role.length === 0 ? (
          <div />
        ) : (
          <>
            <ThemeProvider theme={navbarTheme}>
              <Hidden mdDown>
                <Paper className={classes.navbar} square>
                  <NavbarLayoutFinanceiro />
                </Paper>
              </Hidden>

              <Hidden lgUp>
                <Drawer
                  anchor="left"
                  variant="temporary"
                  open={navbar.mobileOpen}
                  classes={{
                    paper: classes.navbarMobile,
                  }}
                  onClose={() => dispatch(Actions.navbarCloseMobile())}
                  ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                  }}
                >
                  <NavbarMobileLayoutFinanceiro />
                </Drawer>
              </Hidden>
            </ThemeProvider>

            {config.navbar.display && !config.toolbar.display && (
              <Hidden lgUp>
                <NavbarMobileToggleFab />
              </Hidden>
            )}
          </>
        )}
      </>
    )
  );
}

export default NavbarWrapperLayoutFinanceiro;
